import {App} from './App'
import Search from './pages/Search'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'
import {TransitionType} from '@github-ui/react-core/app-routing-types'
import {jsonRoute} from '@github-ui/react-core/json-route'

export const routes = [
  // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
  jsonRoute({path: '/search', Component: Search, transitionType: TransitionType.TRANSITION_WHILE_FETCHING}),
  // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
  jsonRoute({
    path: '/:user/:repo/search',
    Component: Search,
    transitionType: TransitionType.TRANSITION_WHILE_FETCHING,
  }),
]

// eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
registerNavigatorApp('blackbird-search', () => ({
  App,
  routes,
}))
